const REFRESH_MARGIN_MS = 60_000;

/** Aligné web `AuthentificationService.REFRESH_MARGIN_SECONDS` (60 s). */
export function isMobileAccessTokenExpiredOrNearExpiry(token: string | null | undefined): boolean {
  if (!token?.trim()) {
    return true;
  }

  try {
    const payloadSegment = token.split(".")[1];
    if (!payloadSegment) {
      return true;
    }
    const payload = JSON.parse(atob(payloadSegment)) as { exp?: number };
    if (typeof payload.exp !== "number") {
      return true;
    }
    return Date.now() >= payload.exp * 1000 - REFRESH_MARGIN_MS;
  } catch {
    return true;
  }
}
